<template>
  <el-row type="flex" justify="center">
      <el-col :xs="24" :sm="24" :md="22" :lg="14">
          <el-card :body-style="{ padding: '40px 20px' }" class="mt-10">
              <el-row>
                  <el-col :xs="22" :sm='10' :md="10" :lg="10" :offset="1"> 
                      <el-card>
                          <div slot="header" class="clearfix">
                            <span>发布者基本信息</span>
                        </div>
                        <ul class="publisher-list-item">
                            <li>
                                发布间隔时间：
                                <el-tag>{{publisherInfo.interval}}</el-tag> <span>分钟</span> 
                            </li>
                            <li>
                                发布新闻条数：
                                <el-tag>{{publisherInfo.step}}</el-tag><span>条</span>
                            </li>
                            <li>
                                状态：
                                <el-tag :type="publisherInfo.state ? 'success':'danger'">{{publisherInfo.serverTime}}</el-tag>
                            </li>
                        </ul>
                      </el-card>
                  </el-col>
                  <el-col :xs="22" :sm="10" :md="11" :lg="11" :offset="1">
                      <el-card>
                        <div slot="header" class="clearfix">
                            <span>修改发布者参数</span>
                        </div>
                        <el-form :model="publisher" :rules="rules" ref="publisher" label-width="120px">
                            <el-form-item label="发布间隔时间" prop="interval">
                                <el-input v-model="publisher.interval"></el-input>
                            </el-form-item>
                            <el-form-item label="发布新闻条数" prop="step">
                                <el-input v-model="publisher.step"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button @click="setPublisherConfirm('publisher')">设置</el-button>
                            </el-form-item>
                        </el-form>
                      </el-card> 
                  </el-col>
              </el-row>
              
          </el-card>
      </el-col>
  </el-row>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import '../../static/style/stats/publisher.scss'
import { getNowTime } from '../../utils/com.js'
import { Loading,message } from 'element-ui';

export default {
  data(){
      return{
          publisher:{
              interval:null,
              step:null
          },
          rules:{
            interval:[
            { required: true, message: '请输入发布间隔时间', trigger: 'blur' }
            ],
            step:[
            { required: true, message: '请输入发布新闻条数', trigger: 'blur' }
            ]
          }
      }
  },
  created(){
      this.reqPublisherData();
      console.log(this.publisherInfo);
  },
  computed:{
      ...mapGetters({
              // 映射 this.publisherInfo 为 store.getters.publisherInfo
              publisherInfo: 'publisherInfo',
          }),
  },
  methods:{
      ...mapActions({
            // 映射 this.getPublisherData() 为 this.$store.dispatch('getPublisherData')
            getPublisherData: 'getPublisherData',
            setPublisherData: 'setPublisherData',
            updateLoadingStatus: 'updateLoadingStatus',
      }),
      reqPublisherData:function(){
            this.getPublisherData('get');
      },
      setPublisherConfirm:function(formName){
          this.$refs[formName].validate((valid) => {
              if(valid){
                let params = this.publisher;
                params.control = 'set';
                var _that_ = this;
                this.$confirm('确认设置发布者参数?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info'
                }).then(function(){
                    _that_.updateLoadingStatus(true);
                    _that_.setPublisherData(params).then(
                        (resp) => {
                            _that_.updateLoadingStatus(false);
                            if(resp.code === 0){
                                 _that_.$message({
                                    type: 'success',
                                    message: resp.msg
                                });
                                _that_.getPublisherData('get');  
                            }else{
                                 _that_.$message({
                                     message: resp.msg,
                                     type: 'error'
                                })
                            }         
                        }
                    )    
                }).catch(() => {
                _that_.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
                });
              }
          })
        
      },
      }
  }

</script>




// WEBPACK FOOTER //
// publisher.vue?583194ab